import { useCallback, useState } from 'react';
import { setObjectProperty } from '../util/set-object-property';
export function useForm({ initialState, resetState }) {
    const [formState, setFormState] = useState(initialState);
    const handleInputChange = useCallback((field) => (event) => {
        setFormState((prev) => {
            const newFormState = Object.assign({}, prev);
            if (event.target instanceof HTMLInputElement &&
                event.target.files &&
                event.target.files.length > 0) {
                // Handle file inputs
                setObjectProperty(newFormState, field, event.target.files);
            }
            else {
                // Handle other inputs
                setObjectProperty(newFormState, field, event.target.value);
            }
            return newFormState;
        });
    }, []);
    const handleChange = useCallback((field) => (value) => {
        setFormState((prev) => setObjectProperty(Object.assign({}, prev), field, value));
    }, []);
    const resetForm = useCallback(() => {
        setFormState(resetState || initialState);
    }, [resetState, initialState]);
    return { formState, handleInputChange, handleChange, resetForm };
}
export default useForm;
